import { useMemo } from 'react';

// material-ui
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';

// project-imports
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import MiniDrawerStyled from './MiniDrawerStyled';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';
import useThemeConfig from 'hooks/useThemeConfig';

interface Props {
  window?: () => Window;
}

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //
// Icon rail stays permanently visible and collapsed. Hovering it expands the labels; moving the
// pointer away collapses it again. Touch devices have no hover, so there a tap on the rail toggles.

export default function MainDrawer({ window }: Props) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened ?? false;
  const { colorConfig } = useThemeConfig()
  console.log("color config data", colorConfig)

  const noHover = useMediaQuery('(hover: none)');

  // header content
  const drawerContent = useMemo(() => <DrawerContent />, []);
  const drawerHeader = useMemo(() => <DrawerHeader open={drawerOpen} />, [drawerOpen]);

  return (
    <Box
      component="nav"
      onMouseEnter={noHover ? undefined : () => handlerDrawerOpen(true)}
      onMouseLeave={noHover ? undefined : () => handlerDrawerOpen(false)}
      onClick={noHover ? () => handlerDrawerOpen(!drawerOpen) : undefined}
      sx={{
        flexShrink: { md: 0 },
        width: drawerOpen ? DRAWER_WIDTH : MINI_DRAWER_WIDTH,
        transition: (theme) =>
          theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: drawerOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen
          }),
        zIndex: 1200,
        background: "#000 !important"
      }}
      aria-label="mailbox folders"
    >
      <MiniDrawerStyled variant="permanent" open={drawerOpen}>
        {drawerHeader}
        {drawerContent}
      </MiniDrawerStyled>
    </Box>
  );
}
